import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

export class ErrorNotification {

    static render( message, title, type= "danger"){
       
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });        
    }    
}